import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "payment"
    }}>{`Payment`}</h1>
    <p>{`We have introduced the new `}<inlineCode parentName="p">{`Payment`}</inlineCode>{` architecture feature on Pixer `}<inlineCode parentName="p">{`v2.3.0`}</inlineCode>{`. So if you want to use `}<inlineCode parentName="p">{`Payment`}</inlineCode>{` with `}<inlineCode parentName="p">{`Pixer`}</inlineCode>{`, then make sure your Pixer is `}<inlineCode parentName="p">{`v2.3.0`}</inlineCode>{` or later.`}</p>
    <p>{`We have plan to enrich this feature area by integrating more payment gateways in future. List of available payment gateways now.`}</p>
    <ul>
      <li parentName="ul">
        <b>Stripe</b>
      </li>
      <li parentName="ul">
        <b>PayPal</b>
      </li>
      <li parentName="ul">
        <b>RazorPay</b>
      </li>
      <li parentName="ul">
        <b>Mollie</b>
      </li>
      <li parentName="ul">
        <b>Paystack</b>
      </li>
      <li parentName="ul">
        <b>Coinbase</b>
      </li>
      <li parentName="ul">
        <b>Bitpay</b>
      </li>
    </ul>
    <p>{`Let's discuss those sequentially.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      